import { useEffect, useState } from "react";
import MyLeadsBusinessRetailMobile from "./MyLeadsBusinessRetailMobile";
import MyLeadsBusinessRetailWeb from "./MyLeadsBusinessRetailWeb";

export default function MyLeadsBusinessRetail() {
  const [isMobile, setIsMobile] = useState(
    window.matchMedia("(max-width: 768px)").matches
  );

  useEffect(() => {
    const media = window.matchMedia("(max-width: 768px)");
    const handler = () => setIsMobile(media.matches);

    media.addEventListener("change", handler);
    return () => media.removeEventListener("change", handler);
  }, []);

  return isMobile ? (
    <MyLeadsBusinessRetailMobile />
  ) : (
    <MyLeadsBusinessRetailWeb />
  );
}
